import React from 'react';

export const Step1Icon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
		<g fill="none" fillRule="evenodd">
			<path fill="#6E0FEA" d="M15 0L27.99 7.5 27.99 22.5 15 30 2.01 22.5 2.01 7.5z"/>
			<path fill="#FFF" fillRule="nonzero" d="M16.432 19.688L16.432 11 13.24 11 13.24 12.692 14.536 12.692 14.536 19.688z"/>
		</g>
	</svg>

);

export const Step2Icon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
		<g fill="none" fillRule="evenodd">
			<path fill="#6E0FEA" d="M15 0L27.99 7.5 27.99 22.5 15 30 2.01 22.5 2.01 7.5z"/>
			<path fill="#FFF" fillRule="nonzero" d="M18.344 19v-1.692h-4.2c3.048-1.716 4.26-2.856 4.26-4.404 0-1.704-1.308-2.688-3.468-2.688-1.932 0-3.192.96-3.456 2.64l1.764.264c.144-.792.78-1.248 1.692-1.248.912 0 1.548.456 1.548 1.224 0 .948-.384 1.548-4.908 4.236V19h6.768z"/>
		</g>
	</svg>
);

export const LastStepIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
		<g fill="none" fillRule="evenodd">
			<path fill="#F1F1F1" d="M15 0L27.99 7.5 27.99 22.5 15 30 2.01 22.5 2.01 7.5z"/>
			<path fill="#535353" d="M13.128 8.512c.344-1.23 1.074-1.58 1.644-1.501.58.098.997.612.974 1.2 0 1.608 1.44 3.55 2.555 4.32l.092.053c.097.046.203.07.313.07.15 0 .271.122.271.272v6.624c0 .112-.064.214-.165.263C16.645 20.861 15.926 21 14.162 21c-.203 0-1.358-.012-1.78-.012-1.57 0-2.613-.911-3.194-2.798l-1.113-3.729-.005-.02c-.149-.488-.057-1.018.246-1.428.304-.41.784-.651 1.294-.651h3.267c.25 0 .485-.129.619-.341.134-.213.149-.48.04-.706-.323-.82-.532-1.93-.408-2.803zm8.484 3.41c.162 0 .293.132.293.293v8.197c0 .162-.131.293-.293.293h-.878c-.485 0-.878-.394-.878-.878v-7.172h.015c.07-.422.436-.731.863-.732z"/>
		</g>
	</svg>
);

